<template>
  <el-tabs v-if="loginTypes && loginTypes.length > 1" v-model="loginType" @tab-click="loginTypeClick">
    <el-tab-pane v-for="lgt in loginTypes" :key="lgt.value" :label="lgt.label" :name="lgt.value"></el-tab-pane>
  </el-tabs>
</template>

<script>
import LoginSso from "../thirdpart/LoginSso";

export default {
  name: "AaaSThirdPartLogin",
  data() {
    return {
      loginType: "self",
      loginTypes: [
        { label: "系统用户", value: "self" },
        LoginSso.loginType
      ]
    };
  },
  methods: {
    loginTypeClick() {
      if (this.loginType === LoginSso.loginType.value) {
        this.emitLoginLoading(true);
        this.emitDefaultLoginVisible(false);
        location.href = LoginSso.getLoginUrl();
      }
    },
    emitLoginLoading(e) {
      this.$emit("loginLoading", e);
    },
    emitDefaultLoginVisible(e) {
      this.$emit("defaultLoginVisible", e);
    }
  }
};
</script>
